import { ActionTree } from 'vuex';
import { InterviewRequestState, BasicDetails, InterviewDetails } from './types';

const actions: ActionTree<InterviewRequestState, any> = {
  setSitter({ commit }, sitter: any) {
    commit('setSitter', sitter);
  },

  saveBasicDetails({ commit }, basicDetails: BasicDetails) {
    commit('setBasicDetails', basicDetails);
  },

  saveInterviewDetails({ commit }, interviewDetails: InterviewDetails) {
    commit('setInterviewDetails', interviewDetails);
  },

  clearInterviewRequest({ commit }) {
    commit('clearAllData');
  },

  setSitterUuid({ commit }, sitterUuid: string) {
    commit('setSitterUuid', sitterUuid);
  },
};

export default actions;
